module.exports = __webpack_public_path__ + "409b8babf069e2824496a027f66a9cba.png";